module.exports = __webpack_public_path__ + "static/media/CourseAccountActivated.24f85cd3.svg";